const PitchDeckTableEmptyRow = () => {
  return <tr class="idea-checker-table-break"></tr>;
};

export default PitchDeckTableEmptyRow;
